module.exports = __webpack_public_path__ + "message-person.png?f4b986d429200af3e7378cbae900a705";


//////////////////
// WEBPACK FOOTER
// ./src/assets/message-person.png
// module id = 6
// module chunks = 0